import React, { useState } from 'react';
import { motion } from 'framer-motion';
import MechaMenu from './MechaMenu';
import './HeroSection.css';

const HeroSection = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMouseEnter = () => {
        setMenuOpen(true);
    };

    const handleMouseLeave = () => {
        setMenuOpen(false);
    };

    return (
        <motion.div 
            className="hero-section" 
            onMouseEnter={handleMouseEnter} 
            onMouseLeave={handleMouseLeave}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <div className="hero-background">
                <div className="hero-content">
                    <motion.h1 
                        className="artist-name hero-artist-name animate-holographic"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 1.2, delay: 0.5 }}
                    >
                        jxles
                    </motion.h1>
                    <motion.p 
                        className="hero-subtitle"
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8, delay: 1 }}
                    >
                        Electronic Music Producer
                    </motion.p>
                </div>
                <MechaMenu isOpen={menuOpen} />
            </div>
        </motion.div>
    );
};

export default HeroSection;